import request from '@/utils/request'

export function getUploadCredential(type) {
  return request({
    url: '/api/Extend/OssDirectUpload/GetUploadCredential',
    method: 'get',
    data: { type }
  })
}

export function confirmUpload(data) {
  return request({
    url: '/api/Extend/OssDirectUpload/ConfirmUpload',
    method: 'post',
    data
  })
}
